/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'confluence.project-pages.improvement.provisioning-background.text': '이 작업은 1분 이내에 완료됩니다',
  'confluence.project-pages.improvement.provisioning-background.title': '프로젝트 페이지 설정 중',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': '해제',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': '완료',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': '다음',
  'project-pages.activating.description':
    '연결된 Confluence 스페이스가 아직 준비되지 않았습니다. 새로 고쳐도 문제가 해결되지 않으면 {contactSupport}.',
  'project-pages.activating.heading': 'Confluence가 아직 로드 중입니다',
  'project-pages.better-together-templates.meeting-notes.action-items-heading': '작업 항목은 무엇입니까?',
  'project-pages.better-together-templates.meeting-notes.agenda-item-label': '어젠더 항목',
  'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': '/Jira를 입력하여 이슈 만들기',
  'project-pages.better-together-templates.meeting-notes.date-label': '날짜',
  'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': '논의 주제',
  'project-pages.better-together-templates.meeting-notes.list-people': '다음으로 사용자를 목록에 추가:',
  'project-pages.better-together-templates.meeting-notes.mention': '멘션',
  'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them':
    '하여 사용자를 작업 항목에 할당',
  'project-pages.better-together-templates.meeting-notes.notes-label': '메모',
  'project-pages.better-together-templates.meeting-notes.page-title': '미팅 메모',
  'project-pages.better-together-templates.meeting-notes.participants-label': '참여자',
  'project-pages.better-together-templates.meeting-notes.project-label': '프로젝트',
  'project-pages.better-together-templates.product-requirements.create-a-jira-issue': '/Jira를 입력하여 이슈 만들기',
  'project-pages.better-together-templates.product-requirements.design-heading': '디자인',
  'project-pages.better-together-templates.product-requirements.embedd-different-data-views':
    'Jira 프로젝트의 다양한 데이터 및 보기를 포함하세요.',
  'project-pages.better-together-templates.product-requirements.heading': '개요',
  'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed':
    '문제를 해결했는지 어떻게 알 수 있습니까?',
  'project-pages.better-together-templates.product-requirements.impact-heading': '영향',
  'project-pages.better-together-templates.product-requirements.inScopeStatus': '범위 내',
  'project-pages.better-together-templates.product-requirements.insert-design-link': '디자인에 링크 삽입(Figma 등)',
  'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Jira 이슈',
  'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Jira 로드맵',
  'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links':
    '스마트 링크로 사용 방법 알아보기',
  'project-pages.better-together-templates.product-requirements.list-dashboards':
    '대시보드를 목록에 추가(Amplitude, Mode 등)',
  'project-pages.better-together-templates.product-requirements.list-design-considerations':
    '디자인 또는 빌드 고려 사항을 목록에 추가',
  'project-pages.better-together-templates.product-requirements.list-people': '다음으로 사용자를 목록에 추가:',
  'project-pages.better-together-templates.product-requirements.mention': '멘션',
  'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them':
    '하여 사용자를 작업 항목에 할당',
  'project-pages.better-together-templates.product-requirements.niceToHaveStatus': '권장 사항',
  'project-pages.better-together-templates.product-requirements.outOfScopeStatus': '범위 외',
  'project-pages.better-together-templates.product-requirements.page-title': '제품 요구 사항',
  'project-pages.better-together-templates.product-requirements.pro-tip': '전문가 팁:',
  'project-pages.better-together-templates.product-requirements.problem-label': '문제',
  'project-pages.better-together-templates.product-requirements.requirement-heading': '요구 사항',
  'project-pages.better-together-templates.product-requirements.scope-heading': '범위',
  'project-pages.better-together-templates.product-requirements.success-metric': '성공 메트릭',
  'project-pages.better-together-templates.product-requirements.target-release-date': '목표 릴리스 날짜',
  'project-pages.better-together-templates.product-requirements.team-label': '팀',
  'project-pages.better-together-templates.product-requirements.to-do-list-heading': '할 일 목록',
  'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix':
    '해결하려는 문제가 무엇입니까?',
  'project-pages.better-together-templates.retro-notes.retro-heading': '회고',
  'project-pages.better-together-templates.retro.action-items-heading': '작업 항목은 무엇입니까?',
  'project-pages.better-together-templates.retro.create-a-jira-issue': '/Jira를 입력하여 이슈 만들기',
  'project-pages.better-together-templates.retro.date-label': '날짜',
  'project-pages.better-together-templates.retro.embed-it-here': '모두 마쳤으면 여기에 포함할 수 있습니다.',
  'project-pages.better-together-templates.retro.list-people': '다음으로 사용자를 목록에 추가:',
  'project-pages.better-together-templates.retro.mention': '멘션',
  'project-pages.better-together-templates.retro.mention-people-to-assign-them': '하여 사용자를 작업 항목에 할당',
  'project-pages.better-together-templates.retro.page-title': '회고',
  'project-pages.better-together-templates.retro.participants-label': '참여자',
  'project-pages.better-together-templates.retro.pro-tip': '전문가 팁:',
  'project-pages.better-together-templates.retro.project-label': '프로젝트',
  'project-pages.better-together-templates.retro.this-is-a-whiteboard': 'Confluence 화이트보드입니다.',
  'project-pages.better-together-templates.retro.use-a-whiteboard': '회고에 Confluence 화이트보드를 사용하세요.',
  'project-pages.better-together-templates.retro.use-it-to-vote': '투표하고 팀과 공동 작업하는 데 사용하세요.',
  'project-pages.button.connect-different-space-or-page.label': '스페이스 또는 페이지 업데이트 아이콘',
  'project-pages.button.connect-different-space-or-page.tooltip': '다른 스페이스 또는 항목 연결',
  'project-pages.button.connect-space-or-page.tooltip': 'Confluence에 연결',
  'project-pages.button.go-to-connected-live-doc.tooltip': 'Confluence에서 라이브 문서 열기',
  'project-pages.button.go-to-connected-page.tooltip': 'Confluence에서 페이지 열기',
  'project-pages.button.go-to-connected-space.tooltip': 'Confluence에서 스페이스 열기',
  'project-pages.connect-space-dialog.connection-error': '연결에 실패했습니다.',
  'project-pages.connect-space-dialog.connection-retry': '다시 시도',
  'project-pages.connect-space-dialog.content.space-or-page-selector.description':
    '프로젝트에 연결할 스페이스 또는 항목을 선택합니다.',
  'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Confluence 검색',
  'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description':
    '항목을 만들려면 먼저 이 프로젝트를 스페이스에 연결해야 합니다. 이 프로젝트에 연결할 스페이스를 선택하세요.',
  'project-pages.connect-space-dialog.error-icon': '오류:',
  'project-pages.connect-space-dialog.footer.cancel': '취소',
  'project-pages.connect-space-dialog.footer.connect-space': '연결',
  'project-pages.connect-space-or-page-dialog.header.title': 'Confluence에 프로젝트 연결',
  'project-pages.connect-space.description':
    '스페이스는 폴더처럼 프로젝트와 관련된 모든 내용을 만들고 정리하고 공동 작업하는 데 사용할 수 있습니다.',
  'project-pages.connect-space.not-connected.description':
    '프로젝트 페이지를 사용하려면 관리자나 팀 리더에게 문의하여 Confluence를 이 프로젝트에 연결하세요.',
  'project-pages.connect-space.not-connected.heading': 'Confluence에 연결되지 않음',
  'project-pages.connect-success-flag.description.content': '{connectedSpaceOrPageName}개의 콘텐츠에 연결했습니다.',
  'project-pages.connection-error.space-or-page-not-found.button': '다른 스페이스 또는 페이지에 연결',
  'project-pages.create-space-dialog.connection-error': '연결에 실패했습니다.',
  'project-pages.create-space-dialog.connection-retry': '다시 시도',
  'project-pages.create-space-dialog.content.empty-name': '스페이스의 이름을 지정하세요.',
  'project-pages.create-space-dialog.content.invalid-name':
    '스페이스 이름에는 하나 이상의 문자 또는 숫자가 필요합니다.',
  'project-pages.create-space-dialog.content.placeholder': '스페이스 이름 입력',
  'project-pages.create-space-dialog.creation-error': '스페이스를 만들지 못했습니다.',
  'project-pages.create-space-dialog.error-icon': '오류:',
  'project-pages.create-space-dialog.footer.cancel': '취소',
  'project-pages.create-space-dialog.footer.create-space': '만들기',
  'project-pages.create-space-dialog.header.title': '새 Confluence 스페이스 만들기',
  'project-pages.cross-join.access-revoked.templates.subtitle':
    '관리자가 Confluence에 대한 액세스 부여를 거부했기 때문에 프로젝트 페이지를 사용할 수 없습니다. 액세스를 요청하려면 사이트 관리자에게 문의하세요.',
  'project-pages.cross-join.access-revoked.templates.title': '프로젝트 페이지를 사용할 권한이 없습니다',
  'project-pages.cross-join.avatar.view-profile': '프로필 보기',
  'project-pages.cross-join.denied-request.templates.subtitle':
    '사이트 관리자가 Confluence 참여에 대한 요청을 거부했기 때문에 프로젝트 페이지를 사용할 수 없습니다.',
  'project-pages.cross-join.denied-request.templates.title': '관리자가 액세스 요청을 거부했습니다',
  'project-pages.cross-join.direct-access.button-subtitle.experimental':
    'Confluence에 액세스할 수 있습니다. 사이트 관리자가 이미 사용자를 승인했습니다.',
  'project-pages.cross-join.errors.unknown-error.description': '새로 고쳐도 문제가 해결되지 않으면 {contactSupport}.',
  'project-pages.cross-join.errors.unknown-error.title': '지금은 프로젝트 페이지를 표시할 수 없습니다',
  'project-pages.cross-join.inline-join-product.button':
    'Confluence에 대한 액세스 권한을 얻게 됩니다. 사이트 관리자가 이미 사용자를 승인했습니다.',
  'project-pages.cross-join.inline-join-product.connected.description': '한곳에서 설명서를 보고, 편집하고, 만드세요',
  'project-pages.cross-join.inline-join-product.connected.title': '프로젝트 페이지에서 팀과 공동 작업하세요',
  'project-pages.cross-join.pending-request.templates.subtitle':
    '사이트 관리자가 Confluence 참여 요청을 받았습니다. 참여가 승인된 경우, 프로젝트 페이지 사용이 시작되며 확인 이메일을 보내드립니다.',
  'project-pages.cross-join.pending-request.templates.subtitle.experiment':
    '승인되면 프로젝트 페이지에 액세스할 수 있는 이메일을 받게 됩니다.',
  'project-pages.cross-join.pending-request.templates.title': 'Confleunce에 대한 액세스를 요청했습니다',
  'project-pages.cross-join.pending-request.templates.title.experiment': '관리자에게 액세스 요청을 보냄',
  'project-pages.cross-join.request-access-without-better-together.connected.description':
    '팀과 함께 프로젝트 설명서를 보고, 편집하고, 만드세요',
  'project-pages.cross-join.request-access.button': '액세스 요청',
  'project-pages.cross-join.request-access.button-subtitle.experimental':
    "'팀에 참가'를 선택하면 Confluence 참가를 요청하고 Atlassian 프로필을 관리자와 공유하는 데 동의하게 됩니다.",
  'project-pages.cross-join.request-access.button.experimental': '팀에 참가',
  'project-pages.cross-join.request-access.connected.description.experimental':
    '팀이 프로젝트 페이지를 사용하여 Jira를 나가지 않고도 프로젝트 설명서에 댓글을 추가하고 프로젝트 설명서를 편집하고 공동 작업하고 있습니다. Confluence에 참가하여 팀의 프로젝트 페이지에 액세스하세요.',
  'project-pages.cross-join.request-access.title': '프로젝트 페이지에 Confluence 액세스 권한 필요',
  'project-pages.cross-join.request-access.title.experiment': '팀을 위한 단일 정보 출처 만들기',
  'project-pages.default-contextual-heading': '프로젝트 페이지는 Confluence에서 제공',
  'project-pages.default-contextual-message':
    'Confluence 페이지로 모든 프로젝트 문서를 한곳에서 만들고 공유하고 공동 작업하세요.',
  'project-pages.default-reactivate-CTA': 'Confluence 다시 활성화',
  'project-pages.default-trial-CTA': 'Confluence 30일 평가판을 사용해보세요.',
  'project-pages.draft-saved-flag.action': '초안 열기',
  'project-pages.draft-saved-flag.description': '초안은 게시하기 전까지 자신만 볼 수 있습니다.',
  'project-pages.draft-saved-flag.title': '초안 저장됨',
  'project-pages.embedded-pages.create-page-error.close-button': '닫기',
  'project-pages.embedded-pages.create-page-error.description': '문제가 발생하여 페이지를 만들 수 없습니다.',
  'project-pages.embedded-pages.create-page-error.title': '페이지를 만들 수 없습니다',
  'project-pages.embedded-pages.create-page-error.try-again-button': '다시 시도',
  'project-pages.embedded-pages.modal.close.button.hint': '닫기',
  'project-pages.embedded-pages.modal.title.button': 'Confluence에서 열기',
  'project-pages.embedded-pages.modal.title.button.hint': '새 탭에서 열기',
  'project-pages.errors.unknown-error.description.non-final': '새로 고쳐도 문제가 해결되지 않으면 {contactSupport}.',
  'project-pages.errors.unknown-error.title.non-final': '지금은 프로젝트 페이지를 표시할 수 없습니다',
  'project-pages.generic-error.button.reload': '페이지 다시 로드',
  'project-pages.generic-error.description': '문제가 발생했습니다. 나중에 다시 시도하세요.',
  'project-pages.generic-error.description.non-final': '문제가 발생했습니다. 나중에 다시 시도하세요.',
  'project-pages.generic-error.heading': '죄송합니다.',
  'project-pages.generic-error.title.non-final': '죄송합니다.',
  'project-pages.generic-info-flag.description':
    '문제가 발생했습니다. 다시 시도하거나 문제가 지속되면 지원 팀에 문의하세요',
  'project-pages.generic-success-flag.description.live-doc': '{connectedSpaceOrPageName} 라이브 문서에 연결되었습니다.',
  'project-pages.generic-success-flag.description.page': '{connectedSpaceOrPageName} 페이지에 연결되었습니다.',
  'project-pages.generic-success-flag.description.space': '{connectedSpaceOrPageName} 스페이스에 연결되었습니다.',
  'project-pages.generic-success-flag.heading.live-doc': '라이브 문서 연결됨',
  'project-pages.generic-success-flag.heading.page': '페이지 연결됨',
  'project-pages.generic-success-flag.heading.space': '스페이스에 연결됨',
  'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': '또는 새 스페이스 만들기',
  'project-pages.granular-pages.connect-space.button': 'Confluence에 연결',
  'project-pages.granular-pages.connect-space.heading': '이 프로젝트를 Confluence 스페이스 또는 항목에 연결',
  'project-pages.improvement.contact-support': '지원팀에 문의',
  'project-pages.improvement.errors.access-error.description': '사이트 관리자에게 문의하여 액세스 권한을 요청하세요.',
  'project-pages.improvement.errors.access-error.title': '프로젝트 페이지를 볼 권한이 없습니다',
  'project-pages.improvement.errors.page-tree-unknown-error.description':
    '연결된 Confluence 스페이스에 페이지를 표시하려는 중에 오류가 발생했습니다. 새로 고쳐도 문제가 해결되지 않으면 {contactSupport}.',
  'project-pages.improvement.errors.page-tree-unknown-error.title':
    '프로젝트 페이지를 표시하는 동안 문제가 발생했습니다',
  'project-pages.improvement.errors.space-or-page-not-found.description':
    '연결했던 Confluence 스페이스 또는 페이지가 이동, 보관 또는 삭제되었습니다. 다시 연결해도 문제가 해결되지 않으면 <link>지원 팀에 문의</link>하세요',
  'project-pages.improvement.errors.space-or-page-not-found.title': '스페이스 또는 페이지를 찾을 수 없음',
  'project-pages.improvement.errors.unknown-error.description': '새로 고쳐도 문제가 해결되지 않으면 {contactSupport}.',
  'project-pages.improvement.errors.unknown-error.title': '지금은 프로젝트 페이지를 표시할 수 없습니다',
  'project-pages.improvement.feature1': 'Jira에서 나가지 않고 문서에 액세스 및 문서 만들기',
  'project-pages.improvement.feature2': '미팅, 스프린트 계획 등을 위한 템플릿',
  'project-pages.improvement.feature3': '자동 업데이트를 위해 Jira에 문서를 동기화',
  'project-pages.improvement.heading-info': '팀의 지식을 캡처하고 일하는 방식을 개선하세요.',
  'project-pages.improvement.heading-info-v2': '팀의 모든 프로젝트 문서를 위한 하나의 공간을 만드세요',
  'project-pages.improvement.learn-more-button': '자세히 알아보기',
  'project-pages.improvement.powered-by': '제공:',
  'project-pages.improvement.powered-by.tooltip': '새 탭에서 Confluence 열기',
  'project-pages.improvement.preview-teaser': '템플릿, 프로젝트 페이지 등을 잠금 해제하세요.',
  'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description':
    '<p>자동 업데이트되는 상태 레이블로 프로젝트 보고서를 최신 상태로 유지하세요.</p> <p>문서에 Jira 티켓을 연결하기만 하면 티켓과 동기화하여 업데이트되는 상태 레이블이 자동으로 표시되므로 수동으로 보고서를 만드는 데 시간을 들일 필요가 없습니다.</p>',
  'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title':
    '이해 관계자에게 원활하게 업데이트',
  'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description':
    '<p>기본 제공되는 템플릿을 사용하여 일관성 있는 문서를 만드세요. 사용하기 쉽고 필요에 따라 사용자 지정할 수 있습니다.</p> <p>프로젝트 페이지에서 바로 템플릿을 사용할 수 있으므로 현재 작업을 종료할 필요가 없습니다. <a>여기</a>에서 모든 템플릿을 찾아보세요.</p>',
  'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': '문서화 표준 통합',
  'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description':
    '<p>Jira의 프로젝트 페이지 탭에서 설명서를 만들고 관리하여 중요한 정보에 대한 단일 정보 출처를 만드세요.</p> <p>프로젝트 페이지가 Confluence에서 실행된다는 사실을 알고 계셨습니까? 최대 10명의 사용자까지 무료입니다. 관리자 설정에서 다른 팀원을 초대하세요.</p>',
  'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title':
    '프로젝트 페이지를 Jira에서 바로 확인',
  'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Jira 데이터와 통합된 템플릿',
  'project-pages.improvement.templates.better-together-preview-teaser': 'Jira 데이터와 통합됨',
  'project-pages.improvement.templates.blank-page.description': '처음부터 페이지를 시작하세요.',
  'project-pages.improvement.templates.blank-page.name': '빈 페이지',
  'project-pages.improvement.templates.decision.description':
    '중요한 프로젝트 결정을 기록하고 기록한 내용을 팀에 전달하세요.',
  'project-pages.improvement.templates.decision.name': '결정',
  'project-pages.improvement.templates.meeting-notes.description':
    '회의 어젠더를 정하고 메모하고 팀에게 작업 항목을 공유하세요.',
  'project-pages.improvement.templates.meeting-notes.name': '미팅 메모',
  'project-pages.improvement.templates.post-expand.more': '더 많은 템플릿',
  'project-pages.improvement.templates.post-expand.more.tooltip': 'Confluence에서 모든 템플릿 보기',
  'project-pages.improvement.templates.post-expand.subtitle': '인기 템플릿',
  'project-pages.improvement.templates.post-expand.title': '페이지 만들기',
  'project-pages.improvement.templates.pre-expand.more': '더 많은 템플릿 탐색',
  'project-pages.improvement.templates.pre-expand.subtitle': '나의 팀과 비슷한 팀에서 인기',
  'project-pages.improvement.templates.pre-expand.title': '템플릿 미리보기',
  'project-pages.improvement.templates.product-requirements.description':
    '제품 또는 기능에 대한 요구 사항을 정의하고 추적하고 범위를 지정합니다.',
  'project-pages.improvement.templates.product-requirements.name': '제품 요구사항',
  'project-pages.improvement.templates.retrospective.description':
    '좋았던 점은 무엇입니까? 개선할 점은 무엇입니까? 팀과 함께 개선 사항을 크라우드소싱',
  'project-pages.improvement.templates.retrospective.name': '회고록',
  'project-pages.improvement.templates.template.disabled-tooltip': '우선 Confluence 스페이스에 연결하세요',
  'project-pages.improvement.templates.tutorial.content.confluence-templates':
    '<b>시간을 절약하고 수동 작업을 줄이세요</b>. Confluence에는 완전히 처음부터 시작할 필요가 없도록 다양한 페이지 <a>템플릿</a>이 있습니다. 기술 문서, 문제 해결 가이드, 프로젝트 계획, 제품 요구 사항 등에 대해 생각해 보세요.',
  'project-pages.improvement.templates.tutorial.content.edit-and-format':
    '<b>편집과 서식 지정이 쉽습니다.</b> 일반적인 단어 서식 지정은 상단 편집 메뉴를 사용하고 <b>/</b>를 입력하면 편리한 여러 통합 기능을 쉽게 삽입할 수 있습니다. <c>/표</c>를 입력하여 표를 삽입하거나 <c>/이미지</c>를 입력하여 이미지를 삽입하세요. <c>/dropbox</c>로 Dropbox 링크를, <c>/microsoft</c>로 Microsoft office 도구를 또는 <c>/trello</c>로 Trello 보드 및 카드를 삽입할 수도 있습니다.',
  'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "/ 뒤에 '표' 또는 '이미지'를 입력하세요",
  'project-pages.improvement.templates.tutorial.content.getting-started-tips':
    '시작하기 위한 몇 가지 팁은 다음과 같습니다.',
  'project-pages.improvement.templates.tutorial.content.handy-links': '편리한 링크',
  'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Jira 및 Confluence 함께 사용하기',
  'project-pages.improvement.templates.tutorial.content.jira-charts':
    '실제 Jira 데이터를 사용하여 페이지에 차트를 만드세요. <c>/Jira 차트</c>를 입력하세요.',
  'project-pages.improvement.templates.tutorial.content.jira-links':
    'Jira 이슈를 페이지의 원하는 위치에 연결하세요. Jira 이슈를 업데이트하면 페이지의 링크가 실시간으로 업데이트됩니다. <c>/Jira</c>를 입력하세요.',
  'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh':
    'Jira 업무 항목을 페이지의 원하는 위치에 연결하세요. 업무 항목을 업데이트하면 페이지의 링크가 실시간으로 업데이트됩니다. <c>/Jira</c>를 입력하세요.',
  'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh':
    'Jira 업무 항목을 페이지의 원하는 곳에 연결하세요. 업무 항목을 업데이트하면 페이지의 링크가 실시간으로 업데이트됩니다. <c>/Jira</c>를 입력하세요.',
  'project-pages.improvement.templates.tutorial.content.jira-roadmaps':
    'Jira 프로젝트를 사용하여 페이지에 대화형 로드맵과 타임라인을 포함하세요. <c>/Jira 로드맵</c>을 입력하세요.',
  'project-pages.improvement.templates.tutorial.content.jira-timeline':
    'Jira 프로젝트를 사용하여 페이지에 대화형 타임라인을 포함하세요. <c>/jira 타임라인</c>을 입력하세요.',
  'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic':
    'Jira Software 고객의 76%가 Confluence를 추가한 후 프로젝트 출시 기간이 단축되었다고 응답했습니다',
  'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding':
    'Jira 고객의 76%가 Confluence를 추가한 후 프로젝트 제공 기간이 단축되었다고 응답했습니다',
  'project-pages.improvement.templates.tutorial.content.spaces-and-pages':
    '<b>스페이스 및 페이지 사용하기</b>. 스페이스는 모든 Confluence 사이트에 속해 있으며 페이지를 범주별로 체계화하는 방법입니다. 스페이스는 여러 폴더 또는 프로젝트이며 페이지는 그 폴더 또는 프로젝트 안의 문서라고 생각하세요. <a>스페이스 사용 방법 자세히 알아보기</a>',
  'project-pages.improvement.templates.tutorial.content.try-it-now': '지금 사용해보기',
  'project-pages.improvement.templates.tutorial.description': '페이지를 편집하는 방법을 알아보세요.',
  'project-pages.improvement.templates.tutorial.name': '프로젝트 페이지에 오신 것을 환영합니다!',
  'project-pages.improvement.terms-and-conditions-v2':
    '&quot;지금 사용해 보기&quot;를 선택하면 Confluence에 등록한다는 것을 확인하고 Atlassian <termsLink>Cloud 서비스 약관</termsLink> 및 <privacyLink>개인 정보 보호 정책</privacyLink>에 동의하게 됩니다.',
  'project-pages.improvement.title': '프로젝트 페이지',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': '페이지 만들기',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-description':
    '모든 프로젝트 문서를 만들고 연결할 수 있도록 Confluence를 추가했습니다. 최대 10명의 사용자까지 무료입니다.',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': '자세히 알아보기',
  'project-pages.improvement.transient-states.empty-state.create-page-button': '첫 페이지 만들기',
  'project-pages.improvement.transient-states.empty-state.description':
    '미팅 메모, 제품 요구 사항, 결정 사항 또는 기타 콘텐츠를 만들어 이 스페이스를 채워보세요.',
  'project-pages.improvement.transient-states.empty-state.title': '이곳은 잠재력으로 가득합니다.',
  'project-pages.improvement.try-button': 'Confluence에서 이 템플릿 사용해 보기',
  'project-pages.improvement.try-it-now': '지금 사용해 보기',
  'project-pages.improvement.try-lozenge': '사용해 보기',
  'project-pages.improvement.try-on-demand-button': '무료로 사용해 보기',
  'project-pages.page-deleted-flag.title': '페이지를 삭제했습니다.',
  'project-pages.page-published-flag.title': '페이지를 게시했습니다.',
  'project-pages.unknown-error.description': '새로 고쳐도 문제가 해결되지 않으면 {contactSupport}.',
  'project-pages.unknown-error.heading': '지금은 프로젝트 페이지를 표시할 수 없습니다',
};
